module.exports = __webpack_public_path__ + "img/stick_hebergements_camping.a6d5895d.svg";